import React, { useEffect, useState } from "react";
import { Carousel, Modal } from "react-bootstrap";
import Swal from "sweetalert2";

import AuthService from "../../../../services/User/AuthService";
import NoticeService from "../../../../services/User/NoticeService";
import HttpError from "../../../../utill/HttpError";

const NoticeSection = () => {
  const [noticeData, setNoticeData] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    fetchAllNotice();
  }, []);

  const fetchAllNotice = async () => {
    try {
      const token = AuthService.getAccessToken();
      const responseData = await NoticeService.fetchCarouselSliderImages(token);

      const { status, message, data } = responseData;

      if (status === "SUCCESS") {
        const images = data?.uti_slider_images || [];
        setNoticeData(images);

        if (images.length > 0) {
          setShow(true);
        }
      } else {
        Swal.fire("Oops!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Oops!", errMsg, "error");
    }
  };

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Important Notice</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {noticeData.length > 0 && (
          <Carousel
            interval={3000}
            controls={noticeData.length > 1}
            indicators={noticeData.length > 1}
          >
            {noticeData.map((item, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={item.image}
                  alt={item.title || `notice-${index}`}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoticeSection;
